import React from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { alertError, toastInfo, confirm } from "actions/ui";
import { sendUserCommand, clearUserCommand } from "actions/commands";
import {Scrollbar} from "react-scrollbars-custom";

class ChannelOptions extends React.Component {

	constructor(props) {
		super(props);

		this.renderCheckbox = this.renderCheckbox.bind(this);
	}

	renderCheckbox(optionName, label, { adminDisabled = false  } = {}) {
		const optionDisabled = 'This option was disabled by site administrator.'

		return <React.Fragment>
			<input
				className="wcFormCheck"
				type="checkbox"
				checked={ !adminDisabled && this.props.configuration[optionName] }
				disabled={ adminDisabled }
				value="1"
				onChange={ e => this.props.onConfigurationChange({ [optionName]: event.target.checked}) }
			/>
			<label className="wcFormCheckLabel" htmlFor="type1">
				{ label }
			</label>
			{ adminDisabled && <div>{ optionDisabled }</div> }
		</React.Fragment>
	}

	render() {
		return <React.Fragment>
			<div className="wcFormRow">
				{ this.renderCheckbox('enableImages', 'Enable Images', { adminDisabled: !this.props.chatConfiguration.interface.input.images.enabled }) }
			</div>
			<div className="wcFormRow">
				{ this.renderCheckbox('enableAttachments', 'Enable File Attachments', { adminDisabled: !this.props.chatConfiguration.interface.input.attachments.enabled }) }
			</div>
			<div className="wcFormRow">
				{ this.renderCheckbox('enableVoiceMessages', 'Enable Voice Messages', { adminDisabled: !this.props.chatConfiguration.interface.input.sounds.enabled }) }
			</div>
		</React.Fragment>
	}

}

ChannelOptions.propTypes = {
	channel: PropTypes.object.isRequired,
	configuration: PropTypes.object.isRequired,
	onConfigurationChange: PropTypes.func.isRequired
};

export default connect(
	(state) => ({
		i18nBase: state.configuration.i18n,
		i18n: state.application.i18n,
		chatConfiguration: state.configuration
	}),
	{ sendUserCommand, clearUserCommand, alertError, confirm, toastInfo }
)(ChannelOptions);